import React, { Component, Fragment } from 'react';
import authService from '../../services/AuthService';
import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Container from 'react-bootstrap/Container';
import Card from 'react-bootstrap/Card';
import api, { apiErrorHandler, apiResponseHandler } from '../../services/AxiosService';
import { isNullOrEmpty } from '../../helpers/LanguageHelpers';

import pdfDownloadImage from '../../content/pdfDownload.png';
import { apiErrorPopup } from '../../helpers/MessagePopup';

class LegalProfile extends Component {
    constructor(props) {
        super(props);

        this.state = {
            id: this.props.userId,
            agreeToBaaTerms: false,
            agreeToBaaSignature: null
        }

        this.needsUpdated = false;
    }

    baaCheckboxHandler = (e) => {
        this.setState({ agreeToBaaTerms: e.target.checked });
        this.needsUpdated = true;
    }

    baaSignatureHandler = (e) => {
        this.state[e.target.id] = e.target.value;
        this.needsUpdated = true;
    }

    saveHandler = (e) => {
        if (this.needsUpdated) {
            let url = "/account/" + this.state.id + "/legal";
            api.post(url, this.state,
                {
                    headers: {
                        Authorization: 'Bearer ' + authService.token
                    }
                })
                .then((response) => {
                    if (response.status != 200) {
                        apiErrorPopup(apiResponseHandler(response));
                    };
                    this.hasChanged = false;
                })
                .catch((error) => {
                    // Major problem!
                    apiErrorPopup(apiErrorHandler(error));
                    return;
                });
        }
    }

    componentDidMount() {

        // Run a query and get the current user info.
        let url = "account/" + this.state.id;
        api.get(url, {
            headers: {
                Authorization: 'Bearer ' + authService.token
            }
        })
            .then(response => {
                if (response.status == 200) {

                    // Just bind the pertinent info.
                    this.setState({
                        id: response.data.id,
                        agreeToBaaTerms: response.data.agreeToBaaTerms,
                        agreeToBaaSignature: response.data.agreeToBaaSignature
                    })
                }
                else {
                    // Major problem - should not happen.  Back to login
                    apiErrorPopup(apiResponseHandler(response));
                }
            })
            .catch(error => {
                // Major problem - should not happen.  Back to login
                apiErrorPopup(apiErrorHandler(error));
                authService.setAuthenticated(null, null, 0, null, null, null, null, false, false, false, false, false, -1, null);
            });
    }

    render() {
        let isClinician = authService.isClearClinician;

        return (
            <Card onMouseLeave={this.saveHandler}>
                <Container>
                    <Form>

                        {isClinician &&
                            <Fragment>
                                <Fragment>
                                    <h4 className="profile_GenInfoHdr">HIPAA Business Associate Agreement</h4>
                                <a href="https://files.clear-cade.com/documents/BAA_122020.pdf" title="Clear Child BAA Agreement" target="_blank"><img width="70px" src={pdfDownloadImage} />Clear Child BAA</a>
                            </Fragment>

                                <Form.Group controlId="exampleForm.ControlInput1">
                                    <Form.Check id="agreeToBaa" checked={this.state.agreeToBaaTerms} onChange={this.baaCheckboxHandler} type="checkbox" inline
                                        label="I represent that I have the full legal authority to sign this BAA, and I have read and understand this BAA. By clicking this box and signing below, I agree to the terms of this BAA."
                                    />
                                </Form.Group>

                                <Form.Group controlId="exampleForm.ControlInput1">
                                    <Form.Label>Authorized Name</Form.Label>
                                    <Form.Control id="agreeToBaaSignature" onKeyUp={this.baaSignatureHandler} type="text" value={this.state.agreeToBaaSignature} placeholder="Full name of BAA signer" />
                                </Form.Group>
                            </Fragment>
                        }

                        <h4 className="profile_GenInfoHdr">Clear Child Terms of Use</h4>
                        <p>
                            <a href="https://clearchildpsychology.com/wp-content/uploads/2020/06/CLEAR-Child-Psych-Terms-of-Service-May2020.pdf" target="_blank" title="Clear Child terms of use">Click to view</a>
                        </p>

                        <h4 className="profile_GenInfoHdr">Clear Child Privacy Policy</h4>
                        <p>
                            <a href="https://www.clearchildpsychology.com/wp-content/uploads/2021/01/Clear_Child_Psych_Privacy_Policy_1_28_2021_updated.pdf" target="_blank" title="Clear Child privacy policy">Click to view</a>
                        </p>

                    </Form>
                </Container>
            </Card>
        )
    }
}

export default LegalProfile;


// WEBPACK FOOTER //
// ./src/components/Profile/LegalProfile.js